import { typographyToCss } from 'shared/lib/mui';
import { css } from 'styled-components';

// The settings panels' "Upgrade to Premium" line and the inline button inside it.
export const premiumUpsell = css`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  margin: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const premiumUpsellLink = css`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  &:hover {
    text-decoration: underline;
  }
`;
